<svg class="compatibility-icon">
  <circle cx="8" cy="8" r="8" [attr.fill]="fillColor" />
</svg>
<a
  mat-button
  color="primary"
  href="{{ getInterfaceUrl(interfaceConfiguration.interface) }}"
  target="_blank"
  appTooltip
  [tooltipContent]="tooltip"
  tooltipPlacement="bottom"
  >{{ interfaceConfiguration.interface.name }}</a
>
<div #tooltip>
  @if (interfaceConfiguration.connector?.name) {
  <span class="text-medium-emphasis">Connector:</span>
  {{ interfaceConfiguration.connector?.name }}<br />
  } @if (interfaceConfiguration.interfaceActivation) {
  <span class="text-medium-emphasis">Activation:</span>
  {{ interfaceConfiguration.interfaceActivation }}<br />
  }
  <span class="text-medium-emphasis">Applicable for Generic flow:</span>
  {{ interfaceConfiguration.applicableForTbmFlow }}<br />

  @if (interfaceConfiguration.interface.thermInterfaceTypes) {
  <div>
    @for ( thermInterfaceType of interfaceConfiguration.interface
    .thermInterfaceTypes; track thermInterfaceType ) {
    <div>
      <hr />
      <span class="text-medium-emphasis">Therm Interface Type: </span>
      <a
        href="{{ getThermInterfaceTypeUrl(thermInterfaceType) }}"
        target="_blank"
        >{{ thermInterfaceType.name }}</a
      >
      <br />
      <span class="text-medium-emphasis">Hot Water:</span>
      {{ getHotWaterLabel(thermInterfaceType.hotWater) }}<br />
      @if (thermInterfaceType.configurationMenuId) {
      <div>
        <span class="text-medium-emphasis">Configuration Menu Id:</span>
        {{ thermInterfaceType.configurationMenuId }}<br />
      </div>
      }
    </div>
    }
  </div>
  }
</div>
